// extracted by mini-css-extract-plugin
export default {"tab":"tab-yPfrk","tabLeft":"tab-left-ju0iF","tabLeftItem":"tab-left-item-qeqoz","tabLeftActive":"tab-left-active-yvWCN","tabRightIcon":"tab-right-icon-vBmha"};